import { render, staticRenderFns } from "./LinkWithPseudo.vue?vue&type=template&id=933842d6&scoped=true&"
import script from "./LinkWithPseudo.vue?vue&type=script&lang=js&"
export * from "./LinkWithPseudo.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithPseudo.vue?vue&type=style&index=0&id=933842d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933842d6",
  null
  
)

export default component.exports